import React from 'react';
import { useParams } from 'react-router-dom';
import DocsPage from './DocsPage';

// The /documentation route — mounted inside the portal shell by App.js, like
// every other page. It reads the slug and hands it down; the TopBar it used to
// carry is gone, because the docs no longer live in a separate "website"
// experience with its own navigation.
//
// /documentation       → the quickstart (the canonical docs landing)
// /documentation/:slug → that specific guide
export default function DocumentationPage() {
  const { slug } = useParams();
  return <DocsPage slug={slug} />;
}
